import { FC } from "react";
import { ReactComponent as YoutubeIcon } from "@/assets/icons/youtube.svg";
import { ReactComponent as FacebookIcon } from "@/assets/icons/facebook.svg";

interface Props {
  className?: string;
  type: "youtube" | "facebook";
}

const NetworkIcon: FC<Props> = ({ type, className }) => {
  switch (type) {
    case "youtube":
      return <YoutubeIcon className={className} />;
    case "facebook":
      return <FacebookIcon className={className} />;
    default:
      return null;
  }
};

export default NetworkIcon;
